import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CreatePinBox } from 'Component/PinBox';
import useAjaibConfig from '@/hooks/useAjaibConfig';
import useCreatePin from '@/hooks/useCreatePin';
import { COOKIE_KEY } from '@/config/constanta';
import Cookies from 'js-cookie';
import { parseJson } from '@ajaibid/utils';
import { styContainer } from './style';
import useEventTracker from './tracker';

const CreatePin = () => {
  const navigate = useNavigate();
  const { eventCreatePin6Digit } = useEventTracker();
  const { error: createPinError, isLoading: createPinLoading } = useCreatePin();
  const { config, isLoading } = useAjaibConfig();
  const is6Digit = config?.is_create_pin_6digit === '1';
  const isRenewPin = parseJson(Cookies.get(COOKIE_KEY.pin_need_change));

  useEffect(() => {
    if (is6Digit) {
      eventCreatePin6Digit();
    }
  }, []);

  const navigateToNextPage = (pin) => {
    navigate('/validate-pin', { state: { pin } });
  };

  return (
    <div className={styContainer}>
      {!isLoading && (
        <CreatePinBox
          length={isRenewPin ? 6 : 4}
          title="Buat PIN"
          description={`PIN terdiri dari ${
            isRenewPin ? 6 : 4
          } angka yang akan kamu gunakan untuk membuka aplikasi dan melindungi datamu.`}
          onComplete={(value) => {
            navigateToNextPage(value);
          }}
          errorMessage={createPinError}
          isLoading={createPinLoading}
        />
      )}
    </div>
  );
};

export default CreatePin;
